export default __webpack_public_path__ + "static/media/theH.4bfcf902.webp";